const COUNTRY_KEY = "kanalearn.country.v1";

export function getCountry(): string | null {
    try {
        return localStorage.getItem(COUNTRY_KEY) || null;
    } catch {
        return null;
    }
}

export function setCountry(code: string | null): void {
    try {
        if (code) {
            localStorage.setItem(COUNTRY_KEY, code);
        } else {
            localStorage.removeItem(COUNTRY_KEY);
        }
    } catch {
        // Best-effort: if storage is unavailable, the preference just won't persist.
    }
}
